/**
 * Glavni zavihek Projekti (docs/ARHITEKTURA.md, 15.5): podzavihki Pregled,
 * Po projektih, Poraba in Nastavitev odstotkov. Podzavihke prikaze glava;
 * ta stran izbere pogled po naslovu. Strezniske poti so zaprte, ce modul pri
 * podjetju ni vklopljen.
 */
import { POGLEDI_PROJEKTOV, type PogledProjektov } from '@koda/shared';
import type { JSX } from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';

import { useBesedilaProjektov } from '../lib/besedila-projektov';
import { PoProjektihStranke } from '../sestavni/projekti/PoProjektih';
import { PorabaProjektovStranke } from '../sestavni/projekti/PorabaProjektov';
import { PregledProjektovStranke } from '../sestavni/projekti/PregledProjektov';
import { OdstotkiProjektov } from './OdstotkiProjektov';

export function ProjektiStran(): JSX.Element {
  const { id = '', pogled = '' } = useParams();
  const [parametri] = useSearchParams();
  const b = useBesedilaProjektov();
  if (!(POGLEDI_PROJEKTOV as readonly string[]).includes(pogled)) {
    return <Navigate to={`/podjetje/${id}/projekti/pregled`} replace />;
  }
  const izbran = pogled as PogledProjektov;
  const projekt = parametri.get('projekt') ?? undefined;
  return (
    <main>
      <h1>{b.pogledi[izbran]}</h1>
      {izbran === 'pregled' && <PregledProjektovStranke podjetje={id} />}
      {izbran === 'po-projektih' && <PoProjektihStranke key={projekt ?? ''} podjetje={id} {...(projekt === undefined ? {} : { zacetniProjekt: projekt })} />}
      {izbran === 'poraba' && <PorabaProjektovStranke podjetje={id} />}
      {izbran === 'odstotki' && <OdstotkiProjektov />}
    </main>
  );
}
